<template>
  <div class="calico-prompt-bubble-page-container">
    <div class="container-bubbles">
      <CalicoPromptBubble prompt="Magna non commodo id lacus amet. Nulla ornare sit sem velit sed ut enim porttitor. Eget lectus lectus ut venenatis laoreet viverra nisl urna?" />
      <CalicoPromptBubble prompt="Magna non commodo id lacus amet. Nulla ornare sit sem velit sed ut enim porttitor." />
    </div>
  </div>
</template>

<script>
import CalicoPromptBubble from '@/components/calico/promptBubble/index.vue';

export default {
  name: 'PromptBubblePage',
  components: {
    CalicoPromptBubble
  }
};
</script>

<style lang="scss">
  .calico-prompt-bubble-page-container {
    @include stack-space($space-large);
    justify-content: center;
    align-items: center;
    width: 100%;
    .container-bubbles {
      padding: $space-large;
      @include stack-space($space-large);
      width: 50%;
    }
  }
</style>
